export default "__VITE_ASSET__CZAE6c1u__"